import React from "react";
import * as CONSTANT from "../../../constants";
import { useLocation } from "react-router-dom";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { useIsDesignV2 } from "../../../hooks/useIsDesignV2";
interface IItemModifiersProps {
  modifiers: any[];
  paragraphClassName?: string;
  showMore: boolean;
}

const ComboItemModifiers: React.FC<IItemModifiersProps> = ({
  modifiers,
  paragraphClassName,
  showMore
}) => {
  const location = useLocation();
  const isItMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2();
  if (modifiers.length === 0) return null;
  const handleModifierCode = (code: string, modifier: any) => {
    const quantity = modifier.quantity > 1 ? `(${modifier.quantity})` : ''
    switch (code) {
      case CONSTANT.ADD:
        return <span className={`ms-0 mb-2 clr-dark-blue ${isDesignV2 ? 'f-w5 f-s14 font-Visby-cf' : ''}`}>{`+ ${modifier?.modifier_name} ${quantity}`}</span>;
      case CONSTANT.NO:
        return <span className={`ms-0 mb-2 clr-dark-blue ${isDesignV2 ? 'f-w5 f-s14 font-Visby-cf' : ''}`}>{`- ${modifier?.modifier_name} ${quantity}`}</span>;
      case CONSTANT.SUB:
        return (
          <>
            <span className={`ms-0 mb-2 clr-dark-blue ${isDesignV2 ? 'f-w5 f-s14 font-Visby-cf' : ''}`}>{`+ ${modifier?.substituted_modifier?.modifier_name}`}</span>
            <span className={`ms-0 mb-2 clr-dark-blue ${isDesignV2 ? 'f-w5 f-s14 font-Visby-cf' : ''}`}>{`-${modifier?.modifier_name}`}</span>
          </>
        );
      default:
        return null;
    }
  };
  const sliceTill = showMore ? modifiers.length : 1;
  return (
    modifiers.length > 0 && (
      <p className={`${isDesignV2 ? 'pt-1' : ''} ${paragraphClassName ? paragraphClassName : ""}`}>
        {modifiers.slice(0, sliceTill).map((modifier: any, index: number) => {
          return (
            <span key={index}>
              {handleModifierCode(modifier.code, modifier)}
              <br />
            </span>
          );
        })}

      </p>
    )
  );
};

export default ComboItemModifiers;
